module.exports = [
  "Wohnungen",
  "Dachgeschosswohnung",
  "Etagenwohnung",
  "Erdgeschosswohnung",
  "Hochparterre",
  "Hochpaterre",
  "Loftwohnung",
  "Maisonettewohnung",
  "Penthouse",
  "Souterrain",
  "Terrassenwohnung",
  "sonstiger Wohnungstyp",
  "Appartment",
  "Apartment",
  "Wohnung",
  "Zimmer",
  "WG-Zimmer",
  "Dachgeschoss",
  "Erdgeschoss",
  "Loft",
  "Maisonette",
  "Penthouse",
  "Sonstige",
  "Souterrain",
  "Terrassenwohnung",
  "Zwangsversteigerung",
  "Eigentumswohnung",
];



// WEBPACK FOOTER //
// ./src/data/flat.js